/**
 * uploadStatus.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";

interface UploadStatusProps {
  status: "idle" | "uploading" | "complete" | "final" | "invalid"
  percent: number
}

export function UploadStatusComponent (props: UploadStatusProps): React.ReactElement<any, any> {
  if (props.status === "idle") {
    return <div></div>;
  } else if (props.status === "complete") {
    return <DoneIcon />;
  } else if (props.status === "invalid") {
    return <ErrorIcon />;
  } else if (props.status === "final") {
    return <i className="fas fa-download"></i>;
  }
  return <CircularProgress size={25} variant="determinate" value={props.percent} />;
}
